// extracted by mini-css-extract-plugin
export default {"sign_up_form_container_container":"sign-up-form-container_sign_up_form_container_container__dTO6M","form_field":"sign-up-form-container_form_field__586U3"};